<template>
    <div class="col-lg-12">
        <v-dialog v-model="dialog" scrollable max-width="75%">
            <v-card flat>
                <v-card-title class="py-0">
                    <h4 class="title">L'importation des participants éffectuée avec succès</h4>
                    <span class="caption">(Veuillez fermer le modal pour revenir sur l'évenement)</span>
                    <v-spacer />
                    <v-btn icon @click="goToEvent()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

            </v-card>
        </v-dialog>

        <v-card class="mx-auto" flat>
            <v-card-title>Importer la liste des acteurs depuis un fichier CSV</v-card-title>
            <v-card-text>
                <vue-csv-import @cleared="clear()" loadBtnText="Charger le fichier" v-model="importedData"
                    :map-fields="heads"></vue-csv-import>
                <div class="pt-2">
                    <v-btn rounded :disabled="importedData.length == 0" :loading="uploading" class="primary"
                        @click.prevent="submit()">
                        <i class="fa fa-save"> </i> Enregister
                        <template v-slot:loader>
                            <span>
                                {{ progression }}%
                                <v-progress-circular width="2" size="20" color="" indeterminate
                                    :value="20"></v-progress-circular>
                            </span>
                        </template>
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import VueCsvImport from '~/components/VueCsvImport.vue'
import axios from "axios"

export default {
    name: 'import',
    components: {
        VueCsvImport
    },
    data() {
        return {
            actors: [],
            importedData: [],
            dialog: false,
            existingContacts: [],
            uploading: false,
            progression: 0,
            pages: 1,
            mxCurrentPage: 1,
            heads: {
                department: 'Department',
                municipality: 'Commune',
                district: 'Arrondissement',
                town: 'Ville/Village',
                place: 'Lieu',
                last_name: 'Nom du producteur',
                first_name: 'Prénom du producteur',
                contact: 'Contact du producteur',
                gender: 'Sexe',
                tranche: 'Tranche d\'age',
                actor_type: 'Type d\'actor',
                organization: 'Organisation',
                event_name: 'Nom de l\'évènement',
                instruction_level: 'Niveau d\'instruction',
                event_type: 'Type de l\'évènement',
                thematique: 'Thématique de l\'évènement',
                objective: 'Objective de l\'évènement',
                maillon: 'Maillons',
                //domaine: 'Domaine',
                Value_chain: 'Chaine de valeur',
                begin_date: 'Date de début',
                end_date: 'Date de fin',
            }
        }
    },
    computed: {
    },
    methods: {

        clear() {
            this.importedData = []
        },

        chunkArray(myArray, chunk_size) {
            var index = 0;
            var arrayLength = myArray.length;
            var tempArray = [];

            for (index = 0; index < arrayLength; index += chunk_size) {
                let myChunk = myArray.slice(index, index + chunk_size);
                // Do something if you want with the group
                tempArray.push(myChunk);
            }

            return tempArray;
        },

        async submitNextChunk(dataChunks, index) {
            let totalChunks = dataChunks.length
            if (totalChunks > 0) {
                let chunk = dataChunks[index]
                // console.log({ chunk });
                let uri = "/api/events-import";

                await axios.post(uri, this.importedData).then(async resp => {
                    this.progression = Math.floor(((index + 1) / totalChunks) * 100)

                    if (resp.data.existing_actors) {
                        this.existingContacts.push(resp.data.existing_actors)
                    }
                    if (index !== totalChunks - 1) {
                        await this.submitNextChunk(dataChunks, index + 1)
                    }
                    else {

                        let message = 'Importation effectuée.\n'
                        this.$store.dispatch('responseMessage', {
                            type: 'yellow',
                            text: message,
                        })
                        this.uploading = false
                        this.dialog = true

                        this.$router.push({ name: 'events.past' })
                    }
                }).catch(err => {
                    console.log(err)
                    let message = 'Une erreur s\'est produite lors de l\'importations des acteurs'
                    this.$store.dispatch('responseMessage', {
                        type: 'red',
                        text: message,
                    })
                    this.uploading = false
                });
            }
        },

        async submit() {
            let dataChunks = this.chunkArray(this.importedData, 200)
            if (dataChunks.length !== 0) {
                this.uploading = true
                this.existingContacts = []
                await this.submitNextChunk(dataChunks, 0)
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/events/import-event.vue